import moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { selectReferredByFullname, selectWorkoutInviteStartTime } from '../Planner/plannerSelectors';
import Theme from '../theme';
import { UserDataConsumer } from '../utils';
import { defaultScale } from '../utils/scaling';
import { InviteScreen } from './InviteScreen';
interface IProps {
  referredByFullname: string;
  workoutInviteStartTime: string;
  navigation?: any;
  landingPage: string | undefined;
  workoutInviteId: string | undefined;
  utm_source: string | undefined;
  personalisedHeader: string | undefined;
  t(key: string, options?: any): string;
}

interface IState {
  error: string | null;
}

class HomeInviteSignup extends PureComponent<IProps, IState> {
  public state = {
    error: null,
  };

  constructor(props: any) {
    super(props);
  }

  public renderInviteText = () => {
    const { t, referredByFullname, workoutInviteStartTime, personalisedHeader } = this.props;
    const startTime =  parseInt(workoutInviteStartTime, 10);
    return (
      <View style={styles.inviteTextContainer}>
        <Text style={styles.subHeader}>
          {t('joinFriendForWorkout', {
            referredByFullname: decodeURI(referredByFullname).replace(
              /\+/g,
              ' ',
            ),
            personalisedHeader: personalisedHeader || 'Fitillion',
          })}
        </Text>
        <Text style={styles.workoutStartText}>
          {t('workoutStart', {
            startTime: moment(startTime).format(
              'HH:mm, dddd, D MMM',
            ),
          })}
        </Text>
      </View>
    );
  }

  public render() {
    const { t, navigation, landingPage, workoutInviteId, utm_source } = this.props;
    const inviterImageSource = this.props.navigation.getParam('inviterImageSource');
    return (
      <InviteScreen
        navigation={navigation}
        renderInviteText={this.renderInviteText}
        t={t}
        renderFixedContent={this.renderInviteText}
        inviterImageSource={inviterImageSource}
        handleBackNavigation={()=>navigation.pop()}
        landingPage={landingPage}
        workoutInviteId={workoutInviteId}
        utm_source={utm_source}
      />
    );
  }
}

const styles = StyleSheet.create({
  subHeader: {
    ...Theme.textStyle.heading,
    marginBottom: defaultScale(10),
    textAlign: 'center',
  },
  inviteTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  workoutStartText: {
    marginBottom: defaultScale(25),
  },
});

const mapStateToProps = (state) => {
  return {
    referredByFullname: selectReferredByFullname(state),
    workoutInviteStartTime: selectWorkoutInviteStartTime(state),
    landingPage: state.deepLinkParamaters.landingPage,
    utm_source: state.deepLinkParamaters.utm_source,
    workoutInviteId: state.deepLinkParamaters.workoutInviteId,
    personalisedHeader: state.deepLinkParamaters.personalisedHeader,
  };
};

export const HomeInviteSignupScreen = translate(['auth', 'formFields'], {
  wait: true,
})(UserDataConsumer(connect(mapStateToProps)(HomeInviteSignup)));
